import { decodeTokenService } from "../services/decodeTokenService";
import { isDelegatedSupportToken } from "../services/supportTestSessionService";
import { getAccessToken } from "../services/authStorage";

// Única fuente de verdad para saltar de website → builder.
// Su única responsabilidad: resolver la base del builder desde el env del ambiente
// (VITE_REACT_APP_URL_BUILDER). El env decide local / dev / prod, no el código.
export const builderBaseUrl = (): string =>
  ((import.meta.env.VITE_REACT_APP_URL_BUILDER as string | undefined)?.trim() ||
    "http://localhost:3000/").replace(/\/+$/, "");

// Arma la URL del editor del builder para un funnel o store del ambiente actual.
// Devuelve null si falta el owner o el websiteId (el caller decide el fallback).
export const builderUrl = (
  websiteId?: string | null,
  section: "funnel" | "store" = "funnel",
  ownerId?: string,
): string | null => {
  const uid = ownerId || decodeTokenService.getUserIdFromToken() || "";
  if (!uid || !websiteId) return null;
  const url = new URL(`/builder/${section}/${uid}/${websiteId}`, builderBaseUrl());
  const token = getAccessToken();
  if (isDelegatedSupportToken(token)) {
    const redirect = new URL("/support-builder", window.location.origin);
    redirect.searchParams.set("entry_path", url.pathname);
    return redirect.toString();
  }
  if (token) url.searchParams.set("token", token);
  return url.toString();
};
